import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ConfigService } from '../config/config.service';
import { ProducaoIndustrial } from '../types/ProducaoIndustrial.type';

@Injectable({
  providedIn: 'root'
})
export class ProducaoRetornoService {

  constructor(private httpClient: HttpClient, private configService: ConfigService) { }

  // Produção Industrial
  getProducaoIndustrial(page: number, size: number, sortField: string, sortDirection: string, instancia: string, dataInicio: string, dataFim: string){
    return this.httpClient.get<any>(`${this.configService.getApiUrlRoot()}/producoes/producaoindustrial?page=${page}&size=${size}&instancia=${instancia}&dataInicio=${dataInicio}&dataFim=${dataFim}`);
  }

  exportarProducaoIndustrial(instancia: string, dataInicio: string, dataFim: string){
    return this.httpClient.get(`${this.configService.getApiUrlRoot()}/producoes/producaoindustrial/exportar?instancia=${instancia}&dataInicio=${dataInicio}&dataFim=${dataFim}`, { responseType: 'blob'});
  }

  // Produção Agrícola Dados Técnicos
  getProducaoAgricolaDadosTec(page: number, size: number, sortField: string, sortDirection: string, instancia: string, dataInicio: string, dataFim: string){
    return this.httpClient.get<any>(`${this.configService.getApiUrlRoot()}/producoes/producaoagricoladadostec?page=${page}&size=${size}&instancia=${instancia}&dataInicio=${dataInicio}&dataFim=${dataFim}`);
  }

  // Produção Agrícola PI
  getProducaoAgricolaPi(page: number, size: number, sortField: string, sortDirection: string, instancia: string, dataInicio: string, dataFim: string){
    return this.httpClient.get<any>(`${this.configService.getApiUrlRoot()}/producoes/producaoagricolapi?page=${page}&size=${size}&instancia=${instancia}&dataInicio=${dataInicio}&dataFim=${dataFim}`);
  }

  // Produção Agrícola Parametros
  getProducaoAgricolaParametros(page: number, size: number, sortField: string, sortDirection: string, instancia: string){
    return this.httpClient.get<any>(`${this.configService.getApiUrlRoot()}/producoes/producaoagricolaparametros?page=${page}&size=${size}&instancia=${instancia}`);
  }

  // Integrar Produção Agrícola PI (legacy)
  integrarProducaoAgricolaPi(request: any){
    return this.httpClient.post(`${this.configService.getApiUrlRoot()}/producoes/producaoagricolapi/integrar`, request, { responseType: 'text' });
  }

  // Integrar Produção Agrícola Dados Técnicos (legacy)
  integrarProducaoAgricolaDadosTec(request: any){
    return this.httpClient.post(`${this.configService.getApiUrlRoot()}/producoes/producaoagricoladadostec/integrar`, request, { responseType: 'text' });
  }

  // === Qualidade ===
  getQualidade(page: number, size: number, instancia: string, dataInicio: string, dataFim: string){
    return this.httpClient.get<any>(`${this.configService.getApiUrlRoot()}/producoes/qualidade?page=${page}&size=${size}&instancia=${instancia}&dataInicio=${dataInicio}&dataFim=${dataFim}`);
  }

  integrarQualidade(request: any){
    return this.httpClient.post<any>(`${this.configService.getApiUrlRoot()}/producoes/qualidade/integrar`, request);
  }

  enviarQualidade(data: any){
    return this.httpClient.post(`${this.configService.getApiUrlRoot()}/producoes/qualidade/enviar`, data, { responseType: 'text' });
  }

  enviarQualidadePorRegistro(empresa: string, filial: string, dataMovimento: string){
    return this.httpClient.post(`${this.configService.getApiUrlRoot()}/producoes/qualidade/enviar-por-registro?empresa=${empresa}&filial=${filial}&dataMovimento=${dataMovimento}`, null, { responseType: 'text' });
  }

  exportarQualidade(){
    return this.httpClient.get(`${this.configService.getApiUrlRoot()}/producoes/qualidade/exportar`, { responseType: 'blob' });
  }

  // === Produção Cana ===
  getProducaoCana(page: number, size: number, instancia: string, dataInicio: string, dataFim: string){
    return this.httpClient.get<any>(`${this.configService.getApiUrlRoot()}/producoes/producaocana?page=${page}&size=${size}&instancia=${instancia}&dataInicio=${dataInicio}&dataFim=${dataFim}`);
  }

  integrarProducaoCana(request: any){
    return this.httpClient.post<any>(`${this.configService.getApiUrlRoot()}/producoes/producaocana/integrar`, request);
  }

  enviarProducaoCana(data: any){
    return this.httpClient.post(`${this.configService.getApiUrlRoot()}/producoes/producaocana/enviar`, data, { responseType: 'text' });
  }

  enviarProducaoCanaPorRegistro(empresa: string, filial: string, dataMovimento: string){
    return this.httpClient.post(`${this.configService.getApiUrlRoot()}/producoes/producaocana/enviar-por-registro?empresa=${empresa}&filial=${filial}&dataMovimento=${dataMovimento}`, null, { responseType: 'text' });
  }

  exportarProducaoCana(){
    return this.httpClient.get(`${this.configService.getApiUrlRoot()}/producoes/producaocana/exportar`, { responseType: 'blob' });
  }

  // === Dados Técnicos (Integração) ===
  integrarDadosTec(request: any){
    return this.httpClient.post<any>(`${this.configService.getApiUrlRoot()}/producoes/producaoagricoladadostec/integrar`, request);
  }

  enviarDadosTec(data: any){
    return this.httpClient.post(`${this.configService.getApiUrlRoot()}/producoes/producaoagricoladadostec/enviar`, data, { responseType: 'text' });
  }

  enviarDadosTecPorRegistro(instancia: string, dataMovimento: string){
    return this.httpClient.post(`${this.configService.getApiUrlRoot()}/producoes/producaoagricoladadostec/enviar-por-registro?instancia=${instancia}&dataMovimento=${dataMovimento}`, null, { responseType: 'text' });
  }

  exportarDadosTec(){
    return this.httpClient.get(`${this.configService.getApiUrlRoot()}/producoes/producaoagricoladadostec/exportar`, { responseType: 'blob' });
  }
}
